import $ from 'jquery';
import 'foundation-sites/js/foundation/foundation';
import 'foundation-sites/js/foundation/foundation.dropdown';
import utils from '@bigcommerce/stencil-utils';
import ProductDetails from '../common/product-details';
import { defaultModal } from './modal';
import 'slick-carousel';

export default function (context) {
    const modal = defaultModal();

    $('body').on('click', '.byo-brand, .button-byo', (event) => {
        event.preventDefault();

        $('.load-options').css("display","block");
        
        const productId = $(event.currentTarget).data('product-id');
        var default_options = $(event.currentTarget).attr("default-options");
        if(default_options){
            var dropdown = "#byo-dropdown-0";
            var options = default_options.split(',');
        }
        else {
            var dropdown = "#byo-dropdown-0";
            var options = new Array();
        }
        
        if(options.length > 0){

            $(".productView-options .productOptions-list li:first-child .productOptions-list-item-content .form-radio").each(function(){
                $(this).prop("checked", true);
            });

        }

        utils.api.product.getById(productId, { template: 'products/byo-options' }, (err, response) => {
        
            $('.byo-options').css("opacity","0.0");
        
            $('.byo-options').html(response);
            
            setTimeout(function(){
            
                $('.byo-options').find('.productCarousel').slick({
                    infinite: false,
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    responsive: [
                        {
                            breakpoint: 1260,
                            settings: {
                                slidesToScroll: 6,
                                slidesToShow: 6
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToScroll: 4,
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 550,
                            settings: {
                                slidesToScroll: 2,
                                slidesToShow: 2
                            }
                        }
                    ]
                });
                
                if(default_options){}
                else{
                    $('.byo-options .productView-price span.price').html("N/A");
                }
                
                if (window.location.href.indexOf("?id") > -1) {
                    $(".option-id").css("display","block");
                }
                
                $('.byo-options').css("opacity","1.0");
                
                $(dropdown + " .byo-dropdown").removeClass("byo-dropdown-close");
                
                $(dropdown + " .byo-dropdown").addClass("byo-dropdown-open");
                
                $(dropdown + " .byo-price").each(function(){
                    
                    var byo_product = $(this).attr("byo-product");

                    utils.api.product.getById(byo_product, { template: 'products/byo-price' }, (err, response) => {
                        $(this).html(response);
                    });
                    
                });
                

                if(options.length > 0){
                    
                    var i;
                    var scroll_position = $(window).scrollTop();

                    $(".product-byo-section .slick-track .productCarousel-slide:first-child .productOptions-list-item-figure").click();
                    $(".product-byo-section .slick-track .productCarousel-slide:first-child").addClass("productCarousel-slide-first");
                    
                    $('html, body').animate({
                        scrollTop: (scroll_position)
                    },0);
                    
                }

                
                $('.load-options').css("display","none");
                
            }, 3000);

            return new ProductDetails($('.byo-options'), context);
            
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/theme/global/byo.js